import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      [theme.fn.largerThan('sm')]: {
        paddingTop: 0,
      },
    },
  }
})
